<template>
    <object
        v-if="icon"
        class="svg-style"
        :data="icon"
        type="image/svg+xml"
        @load="onLoad"></object>
</template>

<script setup lang="ts">
    const props = defineProps<{
        icon?: string;
    }>();

    // Auto-load icons
    const icons = Object.fromEntries(
        Object.entries(
            import.meta.glob('@/assets/images/icons/*.svg', { eager: true })
        ).map(([key, value]) => {
            const filename = key.split('/').pop()!.split('.').shift();
            return [filename, value.default];
        })
    );

    // Lazily load the icon
    const icon = computed(() => {
        return props.icon && icons[props.icon];
    });
</script>

<style scoped>
    .svg-style {
        width: var(--sizing-2xl, 24px);
        height: var(--sizing-2xl, 24px);
        flex-shrink: 0;
    }
</style>
